module.exports = "/dist/montserrat-latin-200.svg?300ee5f89e3ce7f2eca0291bb48c5ff6";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200.svg
// module id = 68
// module chunks = 0